import { articles } from "@/data/articles";
import { parseJsonPost, type JsonPost } from "./schema";

// Eager imports work in both client and SSR builds. Adding JSON requires no code edits.
const files = import.meta.glob("../../content/posts/*.json", { eager: true, import: "default" });
const paths = new Set(articles.flatMap((post) => [post.frPath, post.enPath]));
const slugs = new Set(articles.map((post) => post.slug));
export const jsonPosts: JsonPost[] = Object.entries(files).map(([filename, raw]) => {
  const post = parseJsonPost(raw, filename);
  if (!filename.endsWith(`/${post.slug}.json`)) throw new Error(`${filename}: filename must match slug`);
  if (slugs.has(post.slug) || paths.has(post.frPath) || paths.has(post.enPath)) throw new Error(`${filename}: duplicate blog slug or localized path`);
  slugs.add(post.slug); paths.add(post.frPath); paths.add(post.enPath);
  return post;
}).sort((a, b) => Date.parse(b.datePublished) - Date.parse(a.datePublished) || a.slug.localeCompare(b.slug));
